const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Gap/Gap.tsx';
import * as React from 'react';
import { theme } from 'App/utils/clientSetupManager';
import { css } from '@emotion/css';

const gapSmStyle = css`
    height: ${theme.spacing(1)};
`;

const gapStyle = css`
    height: ${theme.spacing(2)};
`;

const gapMediumStyle = css`
    height: ${theme.spacing(4)};
`;

const gapBigStyle = css`
    height: ${theme.spacing(5)};
`;

export const GapSm = () => <div className={gapSmStyle} />;

export const Gap = () => <div className={gapStyle} />;

export const GapMedium = () => <div className={gapMediumStyle} />;

export const GapBig = () => <div className={gapBigStyle} />;
